<template>
	<div class="hp-card-item" @click="onRedirectTo">
		<div class="hp-card-item__head">
			<div class="hp-card-item__headline">
				<div
					v-if="card.studio"
					class="body-1">
					<span class="op-045">Studio: </span>
					<a
						:href="card.studio.url"
						class="text-bold">
						{{ card.studio.name }}
					</a>
				</div>
				<div
					v-if="card.collection"
					class="body-2">
					<span class="op-045">Collection: </span>
					<span class="text-bold">{{ card.collection.name }}</span>
				</div>
<!--				<span-->
<!--					v-if="card.created_by?.name || card.created_by?.username"-->
<!--					class="hp-card-item__dot">-->
<!--&lt;!&ndash;					<span class="body-2"></span>&ndash;&gt;-->
<!--					<a-->
<!--						:href="card.get_absolute_url"-->
<!--						class="body-2">-->
<!--						{{ card.created_by?.username || card.created_by?.name }}-->
<!--					</a>-->
<!--        		</span>-->
<!--				<span-->
<!--					v-if="card.url"-->
<!--					class="hp-card-item__dot">-->
<!--					<a-->
<!--						href=""-->
<!--						class="body-2">-->
<!--						{{ card.url }}-->
<!--					</a>-->
<!--				</span>-->
<!--				<span-->
<!--					v-if="card.get_absolute_url"-->
<!--					class="hp-card-item__dot">-->
<!--					<a-->
<!--						:href="card.get_absolute_url"-->
<!--						class="body-2">-->
<!--						{{ card.get_absolute_url }}-->
<!--					</a>-->
<!--        		</span>-->
				<div
					v-if="card.rating"
					class="hp-card-item__dot">

					<div class="hp-card-item__feedback">
						<i
							v-for="i in 5"
							:key="i"
							class="feedback__dot"
							:class="{
								'bg-orange': i <= card.rating,
              				}"
						></i>
					</div>
				</div>
				<div
					v-if="card.detailBadges"
					class="hp-card-item__arrow">
					<span
						v-for="badge in card.detailBadges"
						:key="badge.text"
						class="details-badge body-2"
						:class="[badge.iconClass, badge.bgClass]">
						{{ badge.text }}
					</span>
				</div>
			</div>

			<span
				v-if="card.published_date"
				class="body-2 op-045">
				{{ publichedDate }}
      		</span>
			<span
				v-if="card.modified_date"
				class="body-2 op-045">
        		{{ modifiedDate }}
      		</span>
		</div>

		<div class="hp-card-item__body">
			<h3
				v-if="card.name"
				class="headline-4">
				{{ card.name }}
			</h3>
			<p
				v-if="card.description"
				class="hp-card-item__text body-2">
				{{ card.description }}
			</p>

			<div
				v-if="card.pros"
				class="hp-card-item__row">

				<div class="hp-card-item__icons">
					<i class="hp-card-item__icon icon-pros"></i>
				</div>
				<p class="body-2">
					{{ card.pros }}
				</p>
			</div>

			<div
				v-if="card.cons"
				class="hp-card-item__row">

				<div class="hp-card-item__icons">
					<i class="hp-card-item__icon icon-cons"></i>
				</div>
				<p class="body-2">
					{{ card.cons }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
const dayjs = useDayjs();

export default {
	props: {
		card: {
			type: Object,
			default: () => {
			}
		},
	},
	data() {
		return {}
	},
	computed: {
		publichedDate() {
			return this.card.published_date ? dayjs(this.card.published_date).fromNow(true) : null
		},
		modifiedDate() {
			return this.card.modified_date ? dayjs(this.card.modified_date).fromNow(true) : null
		}
	},
	methods: {
		onRedirectTo() {
			const router = useRouter();

			if (this.card?.url?.length) {
				router.push(this.card.url);
			}

			if (this.card?.get_absolute_url?.length) {
				router.push(this.card.get_absolute_url);
			}
		}
	}
}

</script>
